<template>
  <div>
    <mdb-modal :show="modal" @close="close">
        <mdb-modal-header>
            <mdb-modal-title><h3>{{ title }}</h3></mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
           <p> {{ description }} </p>
        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn
            color="grey lighten-1"
            @click="close"
          >
            Abbrechen
          </mdb-btn>
          <mdb-btn
            color="primary"
            @click="save"
          >
            Ja
          </mdb-btn>
        </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn
  } from 'mdbvue'

  export default {
    name: 'DeleteModal',

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        modal: false,
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
    },

    methods: {
      close () {
        this.$emit('close')
      },
      save () {
        this.$emit('save')
      }
    }
  }
</script>
